import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import styles from './stockStyles';
import { withRouter } from 'react-router-dom';
import momentz from 'moment-timezone';
import {
  is_weekend,
  is_WeekendCalendarDate,
} from '../../components/Modals/UOAModal/getDate';
import DocumentMeta from 'react-document-meta';
import { useDispatch, useSelector } from 'react-redux';
import RightSidebar from './RightSidebar';
import TablesSection from './TablesSection';
import ToolTipModal from '../../components/Modals/ToolTip Modal';
import { fetchQuoteInfoFunc } from '../../Shared';
import { setAppStateAction } from '../../actions/appStateAction';
import { fetchAllMain } from '../../Shared/stocks';

const StockHome = ({ match, history, fetchNews, loginCheck }) => {
  const dispatch = useDispatch();
  const { appReducer } = useSelector((state) => state);
  const { isMobile } = appReducer;
  const [stockPageState, setStockPageState] = useState({
    ticker: '',
    symbol: '',
    showModal: false,
    type: '',
    modalDate: momentz.tz(new Date(), 'America/New_York').format('YYYY-MM-DD'),
    date: momentz.tz(new Date(), 'America/New_York').format('YYYY-MM-DD'),
    table1Dropdown: true,
    table2Dropdown: false,
    table3Dropdown: false,
  });

  const setAppState = (payload) => dispatch(setAppStateAction(payload));

  useEffect(() => {
    loginCheck();
    const newDate = momentz
      .tz(new Date(), 'America/New_York')
      .format('YYYY-MM-DD');
    let dateToSend = is_weekend(newDate);
    setStockPageState((prevState) => ({
      ...prevState,
      date: dateToSend,
      modalDate: dateToSend,
    }));
  }, []);

  const fetchAll = (symbol) => {
    const newDate = momentz
      .tz(new Date(), 'America/New_York')
      .format('YYYY-MM-DD');
    let dateToSend = is_WeekendCalendarDate(newDate);
    let timeDate = is_weekend(newDate);
    history.push(`/stocks/${symbol}`);
    localStorage.setItem('SYMBOL', symbol);
    setStockPageState((prevState) => ({
      ...prevState,
      date: timeDate,
      modalDate: timeDate,
    }));
    fetchNews(symbol);
    fetchAllMain(symbol, timeDate, setAppState);
    fetchQuoteInfoFunc(symbol, dateToSend, appReducer, setAppState);
  };

  useEffect(() => {
    match.params.ticker &&
      localStorage.setItem('SYMBOL', match.params.ticker.toUpperCase());
    const symbol = localStorage.getItem('SYMBOL');
    if (symbol && symbol !== '') {
      history.push(`/stocks/` + symbol);
      setStockPageState((prevState) => ({
        ...prevState,
        symbol: symbol,
        ticker: symbol,
      }));
      fetchAll(symbol);
    }
  }, [match.params.ticker]);

  const meta = {
    title: stockPageState.symbol
      ? `${stockPageState.symbol} Stocks - OptionsGeek`
      : 'Stocks - OptionsGeek',
    description: `This ${stockPageState.symbol} option chain tells you how to choose strike price for call options and put options. Live option chain with options volume vs open interest.`,
    canonical: 'https://tools.optionsgeek.com/optionschain',
    keywords:
      'option, chain, open, interest, vs, volume, strike, price, call, put, best, strike, price, live, implied, volatility, chart',
  };

  return (
    <DocumentMeta {...meta}>
      <div
        style={
          isMobile
            ? styles.containerMobile
            : {
              ...styles.container,
              marginLeft: window.innerWidth > 2000 ? 'auto' : '5%',
              width: window.innerWidth > 2000 ? '1600px' : '',
              marginRight: window.innerWidth > 2000 ? 'auto' : '',
            }
        }
      >
        <Grid container spacing={0}>
          <TablesSection
            stockPageState={stockPageState}
            setStockPageState={setStockPageState}
            fetchAll={fetchAll}
          />

          <RightSidebar
            stockPageState={stockPageState}
            setStockPageState={setStockPageState}
          />
          {stockPageState.showModal && (
            <ToolTipModal
              showModal={stockPageState.showModal}
              clickHandler={() =>
                setStockPageState({
                  ...stockPageState,
                  showModal: !stockPageState.showModal,
                })
              }
              onCloseHandler={() =>
                setStockPageState({
                  ...stockPageState,
                  showModal: !stockPageState.showModal,
                })
              }
              isMobile={isMobile}
              type={stockPageState.type}
            />
          )}
        </Grid>
      </div>
    </DocumentMeta>
  );
};

export default withRouter(StockHome);



// WEBPACK FOOTER //
// ./src/Pages/Stock/index.js